"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import React from "react";
import { useTheme } from "next-themes";
import { Button } from "@components/ui/button";
export const ThemeSwitcher = () => {
  const $ = _c(8);
  const {
    setTheme,
    resolvedTheme
  } = useTheme();
  let t0;
  if ($[0] !== resolvedTheme || $[1] !== setTheme) {
    t0 = () => setTheme(resolvedTheme === "dark" ? "light" : "dark");
    $[0] = resolvedTheme;
    $[1] = setTheme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />;
    t2 = <Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />;
    t3 = <span className="sr-only">Toggle theme</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t0) {
    t4 = <Button variant="outline" size="icon" onClick={t0}>{t1}{t2}{t3}</Button>;
    $[6] = t0;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};